"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bernie_logger_1 = require("bernie-logger");
var REDIRECT_BANNER_LOGGER_IDENTIFIER = "redirect-banner-react";
var LoggerUtility = (function () {
    function LoggerUtility() {
    }
    LoggerUtility.prototype.logMessage = function (eventLevel, errorMessage) {
        var clientLogger = require("bernie-client");
        if (clientLogger && clientLogger.ClientLogger && "function" === typeof clientLogger.ClientLogger.getLoggerWithIdentifier) {
            var logger = clientLogger.ClientLogger.getLoggerWithIdentifier(REDIRECT_BANNER_LOGGER_IDENTIFIER);
            if (logger && typeof logger.logEvent === 'function') {
                logger.logEvent(new bernie_logger_1.SystemEvent(eventLevel, errorMessage), errorMessage);
            }
        }
    };
    return LoggerUtility;
}());
exports.LoggerUtility = LoggerUtility;
//# sourceMappingURL=logger-utility.js.map